import { Stack, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { LoyaltyApi } from "@smartrr/shared/interfaces/loyalty/api";
import { useVariantIdToVariantMap } from "@smartrr/shared/utils/useVariantToPurchasableMap";
import React from "react";
import { useSmartrrCustomerSelector } from "@customer-app/state/typedCustomerReduxHooks";

import { OrderVariantImage } from "../../../Subscription/constants";
import { RedeemButton } from "../RedeemButton";
import { SubscriberOnlyBadge } from "../SubscriberOnlyBadge";
import { DEFAULT_VARIANT_TITLE } from "@smartrr/shared/constants";
import { RewardCostBadge } from "../RewardCostBadge";
import { LoyaltyStoreAccess } from "../../store";

export interface VariantCardProps {
  variant: LoyaltyApi.RewardProduct.Type;
}

const VariantImage = ({ variant }: VariantCardProps) => {
  const purchasables = useSmartrrCustomerSelector(state => state.purchasables.purchasables);
  const variantMap = useVariantIdToVariantMap(purchasables);
  return (
    <OrderVariantImage
      purchasableVariant={variantMap[variant.variantId]}
      size="medium"
      className={prefixClassName("item-variant-image")}
    />
  );
};

export const VariantCard = ({ variant }: VariantCardProps) => {
  const isOtpEnabled = LoyaltyStoreAccess.useIsOtpEnabled();
  const showSubscriberOnlyBadge = variant.subscriberOnly && isOtpEnabled;

  return (
    <React.Fragment>
      <RewardCostBadge costInPoints={variant.costInPoints} rewardItemId={variant.id} />
      <VariantImage variant={variant} />
      <RedeemButton item={variant} />
      {showSubscriberOnlyBadge ? <SubscriberOnlyBadge /> : <React.Fragment />}
      <Stack
        direction="column"
        spacing="3px"
        className={prefixClassName("loyalty-reward-item-variant-details")}
        overflow={""}
      >
        <Typography
          variant="body1"
          className={prefixClassName("loyalty-reward-item-product-name")}
          width={"100%"}
        >
          {variant.variant.productName}
        </Typography>
        {variant.variant.variantName === DEFAULT_VARIANT_TITLE ? (
          <React.Fragment />
        ) : (
          <Typography
            variant="caption1"
            className={prefixClassName("loyalty-reward-item-variant-name")}
            width={"100%"}
          >
            {variant.variant.variantName}
          </Typography>
        )}
      </Stack>
    </React.Fragment>
  );
};
